import { FaBell, FaBoxOpen, FaBuffer, FaCreditCard, FaDatabase, FaFileInvoiceDollar, FaGear, FaHexagonNodes, FaHouse, FaLifeRing, FaMoneyBillWave, FaUserGear, FaUsers, FaUserTie, FaWhatsapp, FaWifi } from "react-icons/fa6";

export const NavLinkItemSuperAdmin = [
  { name: "Dashboard", icon: FaHouse, path: "/dashboard-menu", type: "link" },
  {
    name: "Master Data", icon: FaDatabase, type: "accordion",
    subItems: [
      { name: "POP", path: "/dashboard/master-data/pop" },
      { name: "NAS / Mikrotik", path: "/dashboard/master-data/nas" },
      { name: "OLT", path: "/dashboard/master-data/olt" },
      { name: "ODC Utama", path: "/dashboard/master-data/central-odc" },
      { name: "ODC", path: "/dashboard/master-data/odc" },
      { name: "ODP", path: "/dashboard/master-data/odp" },
      { name: "Mapping", path: "/dashboard/master-data/mapping" },
      { name: "Diagram", path: "/dashboard/master-data/diagram" },
    ],
  },
  {
    name: "PPPoE", icon: FaWifi, type: "accordion",
    subItems: [
      { name: "Profile", path: "/dashboard/pppoe/profile" },
      { name: "User", path: "/dashboard/pppoe/user" },
      { name: "PSB", path: "/dashboard/pppoe/psb" },
    ],
  },
  {
    name: "Hotspot", icon: FaHexagonNodes, type: "accordion",
    subItems: [
      { name: "Profile", path: "/dashboard/hotspot/profile" },
      { name: "Vuocher", path: "/dashboard/hotspot/voucher" },
      { name: "Template", path: "/dashboard/hotspot/template" },
      { name: "Mamber", path: "/dashboard/hotspot/member" },
    ],
  },
  {
    name: "Logistik", icon: FaBoxOpen, type: "accordion",
    subItems: [
      { name: "Monitoring Barang", path: "/dashboard/logistic/monitoring" },
      { name: "Keluar Masuk Barang", path: "/dashboard/logistic/movement" },
      { name: "Stock Opname", path: "/dashboard/logistic/stock-opname" },
    ],
  },
  { name: "Tiket Gangguan", icon: FaLifeRing, path: "/dashboard/ticket", type: "link" },
  {
    name: "Invoice", icon: FaBoxOpen, type: "accordion",
    subItems: [
      { name: "Group", path: "/dashboard/invoice/group" },
      { name: "List", path: "/dashboard/invoice/list" },
      { name: "Janji Bayar", path: "/dashboard/invoice/promise-to-pay" },
    ],
  },
  {
    name: "Keuangan", icon: FaMoneyBillWave, type: "accordion",
    subItems: [
      { name: "Akun Bank", path: "/dashboard/finance/bank-account" },
      { name: "Pajak", path: "/dashboard/finance/taxes" },
      { name: "Payment Gateway", path: "/dashboard/finance/payment-gateway" },
      { name: "Laporan", path: "/dashboard/finance/report" },
    ],
  },
  {
    name: "WhatsApp", icon: FaWhatsapp, type: "accordion",
    subItems: [
      { name: "Pesan Wa", path: "/dashboard/whatsapp/message" },
      { name: "No Whatsapp", path: "/dashboard/whatsapp/number" },
      { name: "Template Pesan", path: "/dashboard/whatsapp/template" },
    ],
  },
  {
    name: "Pengguna", icon: FaUserTie, type: "accordion",
    subItems: [
      { name: "Monitoring", path: "/dashboard/whatsapp/message" },
      { name: "Job Desk", path: "/dashboard/whatsapp/number" },
      { name: "Absensi", path: "/dashboard/whatsapp/template" },
    ],
  },
  { name: "Pemberitahuan", icon: FaBell, path: "/dashboard/notif", type: "link" },
  { name: "Pengaturan", icon: FaGear, path: "/dashboard/setting", type: "link" },


  // {
  //   name: "Agensi", icon: FaBoxOpen, type: "accordion",
  //   subItems: [
  //     { name: "Reseler", path: "/dashboard/agensi/reseller" },
  //     { name: "Mitra", path: "/dashboard/agensi/mitra" },
  //     { name: "Marketing", path: "/dashboard/agensi/marketing" },
  //   ],
  // },
  // { name: "Pengguna", icon: FaUserGear, path: "/dashboard/user-manager", type: "link" },
  // { name: "Agenda / Job desk", icon: FaBuffer, path: "/dashboard/jobdesk", type: "link" },
  // { name: "Absensi Karyawan", icon: FaLifeRing, path: "/dashboard/presence", type: "link" },
];